export default __webpack_public_path__ + "static/media/7.f93f66a8.jpg";